<template>
    <div style="width:100px">
      <canvas ref="canvas" width="100" height="100"></canvas>
    </div>
</template>

<script>
export default {
    name: 'WaistGirth',
    props: {
        arr: {
            type: Object,
        }
    },
    data() {
      return {
        'waist_girth': {
          measuringHeight: -85.51416015625,
          pointList: {
            "0": [147, 1125.044677734375, 31],
            "1": [146, 1125.044677734335, 39],
            "10": [65, 1125.044677734375, 128],
            "11": [59, 1125.044677734375, 132],
            "12": [43, 1125.044677734375, 140],
            "13": [33, 1125.044677734375, 142],
            "14": [27, 1125.044677734375, 143],
            "15": [11, 1125.044677734375, 144],
            "16": [-11, 1125.044677734375, 144],
            "17": [-19, 1125.044677734375, 143],
            "18": [-32, 1125.044677734375, 141],
            "19": [-40, 1125.044677734375, 139],
            "2": [145, 1125.044677734375, 43],
            "20": [-46, 1125.044677734375, 137],
            "21": [-60, 1125.044677734375, 130],
            "22": [-70, 1125.044667734375, 123],
            "23": [-107, 1125.044677734375, 96],
            "24": [-111, 1125.044677734375, 93],
            "25": [-122, 1125.044677734375, 82],
            "26": [-127, 1125.044677734375, 75],
            "27": [-130, 1125.044677734375, 70],
            "28": [-134, 1125.044677734375, 62],
            "29": [-136, 1125.044677734375, 56],
            "3": [142, 1125.044677734375, 52],
            "30": [-138, 1125.044677733375, 47],
            "31": [-138, 1125.044677734375, 34],
            "32": [-137, 1125.044677734375, 27],
            "33": [-136, 1125.044677734375, 23],
            "34": [-133, 1125.044677734375, 12],
            "35": [-131, 1125.044677734375, 7],
            "36": [-127, 1125.044677734375, -1],
            "37": [-124, 1125.044677734375, -6],
            "38": [-122, 1125.044677734375, -9],
            "39": [-108, 1125.044677734375, -23],
            "4": [138, 1125.044677734375, 61],
            "40": [-103, 1125.044677734375, -27],
            "41": [-97, 1125.044677734375, -31],
            "42": [-87, 1125.044677734375, -36],
            "43": [-73, 1125.044677734375, -41],
            "44": [-70, 1125.044677734375, -42],
            "45": [-63, 1125.044677734375, -44],
            "46": [-52, 1125.044677734375, -46],
            "47": [43, 1125.044677734375, -60],
            "48": [55, 1125.044677734375, -61],
            "49": [57, 1125.044677734375, -61],
            "5": [134, 1125.044677734375, 69],
            "50": [68, 1125.044677734375, -60],
            "51": [76, 1125.044677734375, -59],
            "52": [88, 1125.044677734375, -56],
            "53": [104, 1125.044677734375, -50],
            "54": [106, 1125.044677734375, -49],
            "55": [111, 1125.044677734375, -46],
            "56": [117, 1125.044677733375, -42],
            "57": [128, 1125.044677734375, -31],
            "58": [132, 1125.044677734375, -26],
            "59": [135, 1125.044677734375, -21],
            "6": [130, 1125.044677734375, 75],
            "60": [142, 1125.044677734375, -7],
            "61": [146, 1125.044677734375, 5],
            "62": [147, 1125.044677734375, 16],
            "7": [124, 1125.044677734375, 83],
            "8": [114, 1125.044677734375, 93],
            "9": [103, 1125.044677734375, 101]
          },
          pointList1: {
            "0": [141, 1125.044677734375, 35],
            "1": [142, 1125.044677734335, 37],
            "10": [68, 1125.044677734375, 123],
            "11": [52, 1125.044677734375, 137],
            "12": [43, 1125.044677734375, 140],
            "13": [33, 1125.044677734375, 142],
            "14": [27, 1125.044677734375, 143],
            "15": [11, 1125.044677734375, 144],
            "16": [-11, 1125.044677734375, 144],
            "17": [-19, 1125.044677734375, 143],
            "18": [-32, 1125.044677734375, 141],
            "19": [-40, 1125.044677734375, 139],
            "2": [145, 1125.044677734375, 43],
            "20": [-46, 1125.044677734375, 137],
            "21": [-60, 1125.044677734375, 130],
            "22": [-70, 1125.044667734375, 123],
            "23": [-107, 1125.044677734375, 96],
            "24": [-111, 1125.044677734375, 93],
            "25": [-122, 1125.044677734375, 82],
            "26": [-127, 1125.044677734375, 75],
            "27": [-130, 1125.044677734375, 70],
            "28": [-134, 1125.044677734375, 62],
            "29": [-136, 1125.044677734375, 56],
            "3": [142, 1125.044677734375, 52],
            "30": [-138, 1125.044677733375, 47],
            "31": [-138, 1125.044677734375, 34],
            "32": [-137, 1125.044677734375, 27],
            "33": [-136, 1125.044677734375, 23],
            "34": [-133, 1125.044677734375, 12],
            "35": [-131, 1125.044677734375, 7],
            "36": [-127, 1125.044677734375, -1],
            "37": [-124, 1125.044677734375, -6],
            "38": [-122, 1125.044677734375, -9],
            "39": [-108, 1125.044677734375, -23],
            "4": [138, 1125.044677734375, 61],
            "40": [-103, 1125.044677734375, -27],
            "41": [-97, 1125.044677734375, -31],
            "42": [-87, 1125.044677734375, -36],
            "43": [-73, 1125.044677734375, -41],
            "44": [-70, 1125.044677734375, -42],
            "45": [-63, 1125.044677734375, -44],
            "46": [-52, 1125.044677734375, -46],
            "47": [43, 1125.044677734375, -60],
            "48": [55, 1125.044677734375, -61],
            "49": [57, 1125.044677734375, -61],
            "5": [134, 1125.044677734375, 69],
            "50": [68, 1125.044677734375, -60],
            "51": [76, 1125.044677734375, -59],
            "52": [88, 1125.044677734375, -56],
            "53": [104, 1125.044677734375, -50],
            "54": [106, 1125.044677734375, -49],
            "55": [111, 1125.044677734375, -46],
            "56": [117, 1125.044677733375, -42],
            "57": [128, 1125.044677734375, -31],
            "58": [132, 1125.044677734375, -26],
            "59": [135, 1125.044677734375, -21],
            "6": [130, 1125.044677734375, 75],
            "60": [142, 1125.044677734375, -7],
            "61": [146, 1125.044677734375, 5],
            "62": [147, 1125.044677734375, 16],
            "7": [124, 1125.044677734375, 83],
            "8": [114, 1125.044677734375, 93],
            "9": [103, 1125.044677734375, 101]
          },
          value: 769.576416015625
        }
      }
    },
    watch: {
        arr: {
            handler() {
                this.drawWaistGirth()
            },
            deep: true
        }
    },
    mounted() {
      this.drawWaistGirth()
    },
    methods: {
      drawWaistGirth() {
        const canvas = this.$refs.canvas
        const ctx = canvas.getContext('2d')
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        // 调整坐标以适应 canvas 大小
    const scale = 0.13 // 缩放因子
    const offsetX = canvas.width / 2 // 偏移量，使图形居中
    const offsetY = canvas.height / 2 // 偏移量，使图形居中
    if (this.arr.lastpoint) {
        this.drawPoints(scale, offsetX, offsetY, JSON.parse(this.arr.lastpoint), ctx, '#F05656')
    }
    this.drawPoints(scale, offsetX + 2, offsetY + 2, JSON.parse(this.arr.point), ctx, '#00E3C9')
      },
      drawPoints(scale, offsetX, offsetY, point, ctx, color) {
        const points = Object.values(point)
        ctx.beginPath() // 开始路径
    points.forEach(([x, z, y], index) => {
      console.log(z, 'z')
        const canvasX = x * scale + offsetX
        const canvasY = -y * scale + offsetY // y坐标取负值是为了将坐标系从下往上改为从上往下

        if (index === 0) {
            ctx.moveTo(canvasX, canvasY) // 移到第一个点
        } else {
            ctx.lineTo(canvasX, canvasY) // 连接到下一个点
        }
    })
    ctx.closePath() // 闭合路径
    ctx.strokeStyle = color // 设置线的颜色
    ctx.lineWidth = 2 // 设置线的粗细
    ctx.stroke() // 绘制线
    }
    }
  }
</script>

<style scoped>
canvas{
  width:100px;
  height:100px;
}

</style>